<template>
    <li class="vehicle-card__wrap" :class="{ 'swiper-slide': vehicle.isSlide }">
        <a :href="(!disableLink && !expired ? vehicle.url : null)" class="vehicle-card">
            <div class="vehicle-card__image">
                <picture v-if="vehicle.hasImageUrl && !imageMissing">
                    <img :srcSet="`${vehicle.imageUrl + '?width=345'} 345w,${vehicle.imageUrl + '?width=600'} 600w,${vehicle.imageUrl + '?width=516'} 516w, ${vehicle.imageUrl + '?width=424'} 424w`"
                        sizes="(max-width:375px) 345px,(max-width:624px) 600px, (min-width: 1125px) 424px, (min-width: 625px) 516px"
                        :src="vehicle.hasImageUrl ? vehicle.imageUrl + '?width=600' : null" @error="imageMissing = true"
                        loading="lazy" alt="" />
                </picture>
                <div v-else class="vehicle-card__image-placeholder"
                    :class="{ 'vehicle-card__image-placeholder--commercial': vehicle.brandAlias == 'volkswagenerhverv' }">
                    <img :src="brandLogoSrcUrl" alt="" role="presentation"
                        :height="(vehicle.brandAlias == 'volkswagenerhverv') ? 58 : 42" loading="lazy" />
                    <p>{{ dictionary.vehicleCardImagePlaceholderText }}</p>
                </div>
                <div class="vehicle-card__expired-notice" v-if="expired">
                    <p class="vehicle-card__expired-notice-headline">{{ expiredHeadline }}</p>
                    <p class="vehicle-card__expired-notice-text">{{ expiredText }}</p>
                </div>
            </div>
            <div class="vehicle-card__info-wrap">
                <p class="vehicle-card__location">{{ vehicle.dealerName }}</p>
                <p class="vehicle-card__model">{{ vehicle.modelName }}</p>
                <p class="vehicle-card__trim">
                    <span>{{ vehicle.modelTrim }}</span>
                    <span class="vehicle-card__range" v-if="vehicle.hasRange">
                        <img src="/assets/images/lightning.svg" role="presentation" alt="" width="10" height="19"
                            loading="lazy" />
                        <span :aria-label="`Elektrisk rækkevidde på ${vehicle.range} km`">
                            {{ vehicle.range }} km
                        </span>
                    </span>
                </p>
                <ul class="vehicle-card__badges">
                    <li>{{ vehicle.modelYear }}</li>
                    <li v-if="vehicle.hasClockedKilometers">{{ vehicle.clockedKilometers.toLocaleString(culture) }} km
                    </li>
                    <li>{{ vehicle.fuelType }}</li>
                </ul>
                <div class="vehicle-card__price-info">
                    <p class="vehicle-card__price" v-if="vehicle.price > 0">{{ vehicle.price.toLocaleString(culture) }} kr. <span class="vehicle-card__price-suffix" v-if="vehicle.isCommercial">ex. moms</span>
                        
                    </p>
                    <p class="vehicle-card__alt-price" v-if="vehicle.leasingPrice > 0"><span
                            class="vehicle-card__alt-price-value">{{
                                vehicle.leasingPrice.toLocaleString(culture) }} kr.</span> /mdr. <br />{{
                                vehicle.leasingType ==
                                    "Privatleasing" ? dictionary.vehicleCommonIncludingVat : dictionary.vehicleCommonExcludingVat }}
                    </p>
                </div>
                <img class="vehicle-card__brand-logo" :src="vehicle.hasBrandLogoUrl ? vehicle.brandLogoUrl : null"
                    loading="lazy" alt="" height="25" style="height:25px" />
            </div>
        </a>
        <FavoriteCarButton v-show="!hideLike" :key="vehicle.id" :vehicleId="vehicle.id" :vehicleNodeId="vehicleNodeId"
            :preLiked="vehicle.isFavorited" wrapClass="vehicle-card__like-button-wrap"
            buttonClass="vehicle-card__like-button p-button-text" />
    </li>
</template>
<script>
import FavoriteCarButton from './favoriteCarButton.vue';
import VueHelpers from '../vueHelpers';
export default {
    name: "vehicleCard",
    props: ['vehicle', 'vehicleNodeId', 'expired','expiredHeadline', 'expiredText', 'hideLike', 'disableLink'],
    components: {
        FavoriteCarButton
    },
    data() {
        return {
            culture: "da-DK",
            imageMissing: false,
            dictionary: [],
        };
    },
    created() {
        const vm = this;
        vm.culture = document.querySelector("html").getAttribute("lang");

        const dictionary = sessionStorage.getItem(VueHelpers.vehicleCardDictionaryCacheKey);
        if (dictionary) {
            vm.dictionary = JSON.parse(dictionary);
        } else {
            fetch('/umbraco/api/resourcesApi/GetVehicleCardDictionary').then((response) => response.json())
                .then((data) => {
                    vm.dictionary = data;
                    sessionStorage.setItem(VueHelpers.vehicleCardDictionaryCacheKey, JSON.stringify(data));
                })
                .catch((error) => {
                    console.log(error);
                });

        }

    },
    computed: {
        brandLogoSrcUrl: function () {
            if (this.vehicle.brandAlias == 'volkswagenerhverv') {
                return '/assets/images/brands/volkswagenErhverv.svg';
            }

            return this.vehicle.brandLogoUrl ?? '/assets/images/brands/defaultBrandLogo.svg';
        }
    }
};
</script>
